"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Vehicle = void 0;
class Vehicle {
    getId() {
        return this.id;
    }
    setId(id) {
        this.id = id;
        return this;
    }
    getVrm() {
        return this.vrm;
    }
    setVrm(vrm) {
        this.vrm = vrm;
        return this;
    }
    getImage() {
        return this.image;
    }
    setImage(image) {
        this.image = image;
        return this;
    }
    getMileage() {
        return this.mileage;
    }
    setMileage(mileage) {
        this.mileage = mileage;
        return this;
    }
    getType() {
        return this.type;
    }
    setType(type) {
        this.type = type;
        return this;
    }
    getManufacturer() {
        return this.manufacturer;
    }
    setManufacturer(value) {
        this.manufacturer = value;
        return this;
    }
    getModel() {
        return this.model;
    }
    setModel(value) {
        this.model = value;
        return this;
    }
    getModelVariant() {
        return this.modelVariant;
    }
    setModelVariant(value) {
        this.modelVariant = value;
        return this;
    }
    getRegistrationYear() {
        return this.registrationYear;
    }
    setRegistrationYear(value) {
        this.registrationYear = value;
        return this;
    }
    getTrim() {
        return this.trim;
    }
    setTrim(value) {
        this.trim = value;
        return this;
    }
    getModelDerivative() {
        return this.modelDerivative;
    }
    setModelDerivative(value) {
        this.modelDerivative = value;
        return this;
    }
    getRegistrationDate() {
        return this.registrationDate;
    }
    setRegistrationDate(value) {
        this.registrationDate = new Date(value);
        return this;
    }
    getFuelType() {
        return this.fuelType;
    }
    setFuelType(value) {
        this.fuelType = value;
        return this;
    }
    getEngineSize() {
        return this.engineSize;
    }
    setEngineSize(value) {
        this.engineSize = value;
        return this;
    }
    getBodyType() {
        return this.bodyType;
    }
    setBodyType(value) {
        this.bodyType = value;
        return this;
    }
    getTransmission() {
        return this.transmission;
    }
    setTransmission(value) {
        this.transmission = value;
        return this;
    }
    getCondition() {
        return this.condition;
    }
    setCondition(value) {
        this.condition = value;
        return this;
    }
    getModelVariantCode() {
        return this.modelVariantCode;
    }
    setModelVariantCode(value) {
        this.modelVariantCode = value;
        return this;
    }
    getManufacturerCode() {
        return this.manufacturerCode;
    }
    setManufacturerCode(value) {
        this.manufacturerCode = value;
        return this;
    }
    getModelDerivativeCode() {
        return this.modelDerivativeCode;
    }
    setModelDerivativeCode(value) {
        this.modelDerivativeCode = value;
        return this;
    }
    getModelCode() {
        return this.modelCode;
    }
    setModelCode(value) {
        this.modelCode = value;
        return this;
    }
    getRegistrationLocation() {
        return this.registrationLocation;
    }
    setRegistrationLocation(value) {
        this.registrationLocation = value;
        return this;
    }
    getVehicleHistory() {
        return this.vehicleHistory;
    }
    setVehicleHistory(history) {
        this.vehicleHistory = history;
        return this;
    }
    getBuildYearCode() {
        return this.buildYearCode;
    }
    setBuildYearCode(buildYearCode) {
        this.buildYearCode = buildYearCode;
        return this;
    }
    getBuildYear() {
        return this.buildYear;
    }
    setBuildYear(buildYear) {
        this.buildYear = buildYear;
        return this;
    }
    getFuelTypeCode() {
        return this.fuelTypeCode;
    }
    setFuelTypeCode(fuelTypeCode) {
        this.fuelTypeCode = fuelTypeCode;
        return this;
    }
    getTransmissionCode() {
        return this.transmissionCode;
    }
    setTransmissionCode(transmissionCode) {
        this.transmissionCode = transmissionCode;
        return this;
    }
}
exports.Vehicle = Vehicle;
exports.default = Vehicle;
